import Box from "@memorang/ui/src/components/Box";
import CustomAvatar from "@memorang/ui/src/components/CustomAvatar";
import { LinearGradient } from "expo-linear-gradient";
import type { TextStyle } from "react-native";
/* -----------------UI--------------- */
import { Avatar, List, Text } from "react-native-paper";
import type { Style } from "react-native-paper/lib/typescript/components/List/utils";
import { useAppTheme } from "../../useAppTheme";

export type LeaderboardListItemProps = {
	title: string;
	rank?: number;
	xp: string;
	hasDivider?: boolean;
	image: string;
	textStyle?: TextStyle;
	avatarType?: "initials" | "identicon";
	isCurrentUser?: boolean;
	avatarTittle?: string;
	isStatic?: boolean;
};

const LeaderboardListItem = (props: LeaderboardListItemProps) => {
	const {
		rank,
		title,
		xp,
		image,
		textStyle,
		avatarTittle,
		isCurrentUser = false,
		avatarType,
		isStatic = false,
	} = props;
	const theme = useAppTheme();
	const renderRight = (p: {
		color: string;
		style?: Style;
	}) => (
		<List.Icon
			{...p}
			icon={() => (
				<Text variant="labelSmall">{`${xp?.toLocaleString() ?? 0} XP`}</Text>
			)}
		/>
	);

	const renderLeft = (p: { color: string; style: Style }) => {
		return (
			<Box flexDirection="row" alignItems="center" {...p}>
				<Box
					style={{
						alignItems: "center",
						justifyContent: "center",
						width: 20,
						height: 16,
					}}
				>
					{rank && <Text variant="bodySmall">{rank}</Text>}
				</Box>
				<List.Icon
					{...p}
					icon={() =>
						avatarType === "identicon" && image?.endsWith?.(".svg") ? (
							<CustomAvatar size={40} avatar={image} />
						) : (
							<Avatar.Text
								size={40}
								label={avatarTittle ?? (title ? title[0] : "")}
								style={{ backgroundColor: theme.colors.primaryContainer }}
								labelStyle={{ color: theme.colors.onPrimaryContainer }}
							/>
						)
					}
					style={p.style}
				/>
			</Box>
		);
	};

	const listItemContent = (
		<List.Item
			title={title}
			style={{
				backgroundColor: isStatic
					? theme.colors.primaryContainer
					: isCurrentUser
						? "transparent"
						: theme.colors.surface,
				borderWidth: 1,
				borderColor: theme.colors.surfaceVariant,
				borderRadius: 8,
			}}
			titleStyle={{
				...(textStyle ?? {}),
			}}
			right={renderRight}
			left={renderLeft}
		/>
	);

	if (isCurrentUser) {
		return (
			<LinearGradient
				colors={[theme.colors.primaryContainer, theme.colors.white]}
				start={{ x: 0, y: 0 }}
				end={{ x: 1, y: 0 }}
				style={{ borderRadius: 8 }}
			>
				{listItemContent}
			</LinearGradient>
		);
	}

	return listItemContent;
};

export default LeaderboardListItem;
